import { Injectable, computed, inject, signal } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CreateGroupDTO, GroupDTO, GroupUserDTO, RemoveUserFromGroupDTO, UpdateGroupDTO } from '../models/group.model';
import { ResponseDTO } from '@app/shared/models/response.model';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  private readonly http = inject(HttpClient);
  private readonly PATH = 'api/group';

  readonly groupsResource = httpResource<GroupDTO[]>(
    () => `${this.PATH}`
  );

  readonly groupsList = computed(() =>
    (this.groupsResource.value() ?? []).map(group => ({
      ...group,
      usersCount: group.webRqaUsers.length
    }))
  );

  getGroupById(groupId: string): Observable<GroupDTO> {
    return this.http.get<GroupDTO>(`${this.PATH}/${groupId}`);
  }

  getGroupUsers(groupId: string): Observable<GroupUserDTO[]> {
    return this.http.get<GroupUserDTO[]>(`${this.PATH}/${groupId}/users`);
  }

  addGroup(group: CreateGroupDTO): Observable<ResponseDTO> {
    return this.http.post<ResponseDTO>(`${this.PATH}`, group);
  }

  updateGroup(group: UpdateGroupDTO): Observable<boolean> {
    return this.http.put<boolean>(`${this.PATH}/${group.id}`, group);
  }

  deleteGroup(groupId: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.PATH}/${groupId}`);
  }

  removeUserFromGroup(removeUserData: RemoveUserFromGroupDTO): Observable<boolean> {
    return this.http.delete<boolean>(`${this.PATH}/${removeUserData.groupId}/users/${removeUserData.username}`);
  }
}
